<template>
  <a-modal :maskClosable="false" :width="800" :visible="true" :title="title" @ok="sub" @cancel="cancel">
    <a-form
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="标题">
        <a-input type="text" v-model="addModal.title"></a-input>
      </a-form-item>
      <!-- <a-form-item label="类型">
        <a-select v-model="addModal.type" >
          <a-select-option :value="'嘉宾票'">嘉宾票</a-select-option>
          <a-select-option :value="'工作人员票'">工作人员票</a-select-option>
          <a-select-option :value="'顾客'">顾客</a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item label="有效时间">
        <a-date-picker
          v-model="addModal.start_time"
          showTime
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="开始时间"
        />
        <span style="margin: 0 5px">-</span>
        <a-date-picker
          v-model="addModal.end_time"
          placeholder="结束时间"
          showTime
          format="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-item>
      <a-form-item label="价格">
        <a-input-number style="width: 200px;" v-model="addModal.price"></a-input-number>
      </a-form-item>
      <a-form-item label="限制张数">
        <a-input-number style="width: 200px;" v-model="addModal.limit"></a-input-number>
      </a-form-item>

      <a-form-item label="优惠券">
        <a-select style="width: 320px" v-model="addModal.coupon_id" @change="selectCoupon">
          <a-select-option :value="0">请选择</a-select-option>
          <a-select-option v-for="(coupon, c) in couponList" :key="c" :value="coupon.id">{{coupon.name}} （满{{coupon.man}}减{{coupon.jian}}）</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="门票规则">
        <Editor
        v-if="showEditor"
          @callback="updateEditor"
          :data="addModal.desc"
          folder="exhibition"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style lang='scss' scoped>
</style>

<script>
import Editor from "../../components/editor";
import moment from "moment";
export default {
  props: ["exh_id", 'id', 'couponList'],
  components:{ Editor },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 19,
        },
      },
      addModal: {
        exh_id: null,
        title: "",
        start_time: null,
        end_time: null,
        price: null,
        limit: null,
        type: '',
        // type: '嘉宾票',
        desc: "",
        coupon_id: '', // 优惠券
        coupon_name: ''
      },
      showEditor: false,
      title: '添加门票'
    };
  },
  created() {
    this.addModal.exh_id = this.exh_id;
    if(this.id) {
      this.getDetail()
      this.title = '编辑门票'
    }else{
      this.showEditor = true
      this.title = '添加门票'
    }
  },
  methods: {
    moment,
    async sub() {
      this.addModal.exh_id = this.exh_id;
      if(!this.addModal.exh_id) return this.$message.error("数据出错了");
      if (!this.addModal.title) return this.$message.error("请填写标题");
      if (!this.addModal.start_time) return this.$message.error("请选择日期");
      if (!this.addModal.end_time) return this.$message.error("请选择日期");
      if(moment(this.addModal.start_time).startOf('D').valueOf() > this.moment(this.addModal.end_time).endOf('D').valueOf())return this.$message.error("开始时间不能大于结束时间");
      if ([null, undefined, false].includes(this.addModal.price) || Number(this.addModal.price) < 0) return this.$message.error("请填写正确的价格");
      if (!this.addModal.limit) return this.$message.error("请填写限制张数");
      let url = "/exh/menpiao/create"
      if(this.id) {
        url = "/exh/menpiao/update"
        this.addModal.id = this.id
      }
      const r = await this.$axios.post(url, this.addModal);

      if (r.status == 1) {
        this.callback(true);
      }
    },

    cancel() {
      // this.addModal = {
      //   exh_id: null,
      //   title: "",
      //   start_time: null,
      //   end_time: null,
      //   price: null,
      //   limit: null,
      //   type: '嘉宾票',
      //   desc: "",
      // }
      // this.id = null
      this.callback(false);
    },

    callback(e) {
      this.$emit("callback", e);
    },
    async getDetail() {
      const r = await this.$axios.post('/exh/menpiao/detail?id=' + this.id)
      if(r.status == 1) {
        r.data.start_time = moment(r.data.start_time)
        r.data.end_time = moment(r.data.end_time)
        this.addModal = r.data
        this.showEditor = true
      }
    },
    updateEditor(data) {
      this.addModal.desc = data
    },

    selectCoupon () {
      for(let item of this.couponList){
        if(item.id == this.addModal.coupon_id){
          this.addModal.coupon_name = item.name
          break
        }
      }
    }

  },
};
</script>